import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth, signInWithPopup, signOut as firebaseSignOut, GoogleAuthProvider } from 'firebase/auth';

initializeApp({
    apiKey: 'AIzaSyAaYLvUTnKuwOzlgkXYkdEIKOwScH5f10o',
    authDomain: 'etiquette-e3b0b.firebaseapp.com',
    projectId: 'etiquette-e3b0b',
    storageBucket: 'etiquette-e3b0b.appspot.com',
    messagingSenderId: '1022901082375',
    appId: '1:1022901082375:web:175537456e9e2f64eecda2',
});
export const db = getFirestore();
export const auth = getAuth();

export const provider = new GoogleAuthProvider();
export const signInWithGoogle = () => signInWithPopup(auth, provider);
export const signOut = () => firebaseSignOut(auth);

export const createUserProfileDocument = async (user) => {
    if (!user) return;

    const getDocRef = doc(db, 'users', user.uid);
    const userSnap = await getDoc(getDocRef);

    if (!userSnap.exists()) {
        const { displayName, email } = user;
        const createdAt = new Date();

        try {
            await setDoc(getDocRef, {
                displayName,
                email,
                createdAt,
            });
        } catch (error) {
            console.error('Error creating user', error);
        }
    }
    return getUserDocument(user.uid);
};

export const getUserDocument = async (uid) => {
    if (!uid) return null;
    try {
        const userRef = doc(db, 'users', uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
            return userSnap.data();
        } else {
            console.log('No such user!');
        }
    } catch (error) {
        console.error('Error fetching user', error.message);
    }
};
